import React from "react";
import styled from "@emotion/styled";
import { DownloadService, RootState, closeTermsAndConditionsModal, i18n, openTermsAndConditionsModal, useAppDispatch, useAppSelector } from "src/common";
import { Card, Divider, Flex, Label, TermsAndConditionsModal, TermsAndConditionsSectionInterface, Text } from 'src/components';
import { colors } from "src/theme";

const ButtonStyle = styled.div({
  cursor: 'pointer'
})

interface InsuranceConditionsCardProps {
  documents: Array<{ title: string, src: string }>;
}

// zove se card iako je samo dio carda - Header
export const InsuranceConditions = ({documents}: InsuranceConditionsCardProps) => {
  const dispatch = useAppDispatch();
  
  const termsAndConditionsModalOpen = useAppSelector((store: RootState) => store.state.modal.termsAndConditionsModal.open);
  
  const termsAndConditions: Array<TermsAndConditionsSectionInterface> = [{
    sectionTitle: i18n.t('components.modals.termsAndConditionsModal.label2'), // SREDITI I IME SEKCIJE KAD I AKO SE DOBIJE SA BE
    sectionContent: documents.map(doc => ({
      text: doc.title,
      action: () => DownloadService.downloadFile(doc.src, `${doc.title}.pdf`)
    }))
  }];
  
  return (
    <>
      <ButtonStyle onClick={() => dispatch(openTermsAndConditionsModal())}>
        <Text type='small' bold color={colors.primary}>{i18n.t('components.cards.insuranceConditionsCard.insuranceConditions')}</Text>
      </ButtonStyle>
      <Divider dashed />
      <Flex vertical gap={8}>
        <div>
          <Label type='small'>{i18n.t('components.cards.insuranceConditionsCard.insuranceStart')}</Label>
          <Text type='small' color={colors.text2}>{i18n.t('components.cards.insuranceConditionsCard.afterWaitingPeriod')}</Text>
        </div>
        <Card radius={4} padding={'6px 12px'} background={colors.background6}>
          <Text type='tiny' color={colors.text2}>{i18n.t('components.cards.insuranceConditionsCard.waitingPeriod')}</Text>
        </Card>
        <div>
          <Label type='small'>{i18n.t('components.cards.insuranceConditionsCard.insuranceLength')}</Label>
          <Text type='small' color={colors.text2}>{i18n.t('components.cards.insuranceConditionsCard.afterTermination')}</Text>
          <Text type='tiny' color={colors.text4}>{i18n.t('components.cards.insuranceConditionsCard.moreInfo')}</Text>
        </div>
      </Flex>

      <TermsAndConditionsModal sections={termsAndConditions} open={termsAndConditionsModalOpen} onClose={() => dispatch(closeTermsAndConditionsModal())} onBackToPaymentButtonPress={() => dispatch(closeTermsAndConditionsModal())} />
    </>
  )
}
